import { useMutation, useQueryClient } from 'react-query';
import Notiflix from 'notiflix';
import axios from 'axios';
import { loadingSvgColor } from 'helpers/utils';

const createNewProject = async data => {
  const res = await axios.post(`/app/bb_datasheep_projects`, data);
  return res.data;
};

export const useCreateNewProjectMutation = () => {
  const queryClient = useQueryClient();
  const { mutate } = useMutation({
    mutationFn: createNewProject,
    onMutate: () => Notiflix.Loading.hourglass({ svgColor: loadingSvgColor }),
    onError: error => {
      Notiflix.Notify.failure(error.message);
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries(['ALL_PROJECTS']);
    },
    onSettled: () => {
      Notiflix.Loading.remove();
    }
  });

  return { mutate };
};
